import React, { createContext, useContext } from 'react';
import { useAlertDialog } from '@/hooks/useAlertDialog';
import { type AlertColor } from '@mui/material';

interface AlertContextType {
  showAlert: (props: {
    severity: AlertColor;
    title?: string;
    message: string;
    duration?: number;
    showCloseButton?: boolean;
    onClose?: () => void;
    action?: React.ReactNode;
    sx?: any;
  }) => string;
  closeAlert: (id: string) => void;
  AlertContainer: React.FC;
}

const AlertContext = createContext<AlertContextType | null>(null);

export const useAlert = (): AlertContextType => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
};

export const AlertProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { showAlert, closeAlert, AlertContainer } = useAlertDialog();

  return (
    <AlertContext.Provider value={{ showAlert, closeAlert, AlertContainer }}>
      {children}
    </AlertContext.Provider>
  );
};
